import Tooltip from '~/shared/components/Tooltip';
import Typography from '~/shared/components/Typography';
import { Volume } from '~/shared/types/api';

export default function TagsTooltip({ volumeId, tags }: Volume) {
  return (
    <Tooltip
      positionStrategy="fixed"
      place="top"
      id={`${volumeId}_tags-column-tooltip`}
      render={() => (
        <div className="flex flex-col gap-1 text-white">
          <Typography variant="p2" className="font-semibold text-white">
            Tags:
          </Typography>
          {tags.map((tag, index) => (
            <div key={index} className="flex gap-2 items-center">
              <div className="size-2 bg-white rounded-full" />
              <Typography variant="p3" className="font-normal  text-white">
                {tag.key}: <span className="font-bold">{tag.value}</span>
              </Typography>
            </div>
          ))}
        </div>
      )}
    />
  );
}
